<template>
  <div>
    <section v-if="images.length" class="position-relative item">
      <v-sheet class="colored" color="#D3E2EB">
        <WaveWidget class="colored-wave" color="#D3E2EB" />
      </v-sheet>

      <v-sheet class="position-relative" color="transparent">
        <v-container>
          <TitleWidget>
            {{ title }}
          </TitleWidget>

          <CarouselWidget
            class="mt-6 mt-md-8"
            :items="images"
            :items-to-show="itemsToShow"
            :gap="10"
          >
            <template #item="{ item }">
              <img class="d-block item-img" :src="item" width="100%" />
            </template>
          </CarouselWidget>

          <ButtonWidget
            class="mt-6 mt-md-8"
            color="primary"
            :to="path"
            align="center"
            text-color="white"
          >
            Ver tudo
          </ButtonWidget>
        </v-container>
      </v-sheet>
    </section>
  </div>
</template>

<script>
import WaveWidget from "../widgets/WaveWidget.vue";
import TitleWidget from "../widgets/TitleWidget.vue";
import CarouselWidget from "../widgets/CarouselWidget/Index.vue";
import ButtonWidget from "../widgets/ButtonWidget.vue";

const _config = {
  mod: "gallery",
};

const _carouselSettings = {
  itemsToShow: {
    xs: 2,
    sm: 2.2,
    md: 3,
    lg: 3,
    xl: 3,
  },
};

const _data = {
  title: "Galeria de Fotos",
  path: "/galeria-de-fotos",
  ..._carouselSettings,
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    item() {
      return this.$rest(_config.mod).item;
    },
    images() {
      return (
        this.item?.img?.list.map(({ path }) => {
          return this.files + path + "?resize=1&w=400";
        }) || []
      );
    },
  },
  created() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    WaveWidget,
    TitleWidget,
    CarouselWidget,
    ButtonWidget,
  },
};
</script>

<style lang="scss" scoped>
.item {
  background-color: #e6eff4;

  &-img {
    border: 11px solid #e6eff4;
    border-radius: 40px;
    aspect-ratio: 360 / 320;
    object-fit: cover;
  }

  .colored {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 50%;

    &-wave {
      bottom: 100%;
      position: absolute;
    }
  }
}
</style>
